var index = {
  root: {
    gap: '1.125rem'
  },
  controls: {
    gap: '0.5rem'
  }
};

export { index as default };
//# sourceMappingURL=index.mjs.map
